const decodeJwtPayload = (idToken) => {
  const payload = idToken.split(".")[1];
  const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
  return JSON.parse(atob(base64));
};

export const decodeClaims = (idToken) => {
  const decoded = decodeJwtPayload(idToken);
  const roles =
    typeof decoded.rls === "string"
      ? decoded.rls.split("|").filter(Boolean)
      : [];
  return { uid: decoded.uid, roles, raw: decoded };
};
